<template>
<v-container fluid>
  <header-summary-table
    v-bind:classification="this.classification"
    v-bind:category="this.category">
    <v-simple-table>
      <thead>
        <tr>
          <th>
            ID
          </th>
          <th>
            Reactants
          </th>
          <th>
            Products
          </th>
          <th>
            T/K
          </th>
          <th>
            &sigma;(max)
          </th>
          <th>
            &lambda;(max)
          </th>
          <th>
            &sigma;
          </th>
          <th>
            &Phi;
          </th>
          <th>
            Absorption cross sections data
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="datasheet in datasheets">
          <template v-if="datasheet.preferredValues.length==0">
            <tr :key="datasheet.pk.codeCategory + datasheet.pk.datasheetNumber">
              <td class="text-left"><a target="_blank" :href="$prodPrefix+'datasheets/pdf/' + datasheet.pk.codeCategory + datasheet.pk.datasheetNumber + '.pdf'" download> {{ datasheet.pk.codeCategory + datasheet.pk.datasheetNumber }} </a></td>
              <td class="text-left" v-html="datasheet.reactants"></td>
              <td class="text-left" v-html="datasheet.products"></td>
              <td class="text-left" colspan="6">See datasheet</td>
            </tr>
          </template>
          <tr v-for="(preferredValue, index) in datasheet.preferredValues" v-bind:key="preferredValue.idPreferredValue">
            <template v-if="index==0">
              <td class="text-left" :rowspan="datasheet.preferredValues.length"><a target="_blank" :href="$prodPrefix+'datasheets/pdf/' + datasheet.pk.codeCategory + datasheet.pk.datasheetNumber + '.pdf'" download> {{ datasheet.pk.codeCategory + datasheet.pk.datasheetNumber }} </a></td>
              <td class="text-left" :rowspan="datasheet.preferredValues.length" v-html="datasheet.reactants"></td>
              <td class="text-left" :rowspan="datasheet.preferredValues.length" v-html="datasheet.products"></td>
            </template>
            <td class="text-left" v-html="preferredValue.photolysisPreferredValue.temperatureRange"></td>
            <td class="text-left" v-html="preferredValue.photolysisPreferredValue.sigmaMax"></td>
            <td class="text-left" v-html="preferredValue.photolysisPreferredValue.lamdaMax"></td>
            <td class="text-left" v-html="preferredValue.photolysisPreferredValue.sigmaExpression"></td>
            <td class="text-left" v-html="preferredValue.photolysisPreferredValue.phiExpression"></td>
            <td class="text-left ">
              <a class="d-flex justify-center align-center text-decoration-none"  v-if="preferredValue.photolysisPreferredValue.isAbsorptionCrossSectionsValues" :href="axiosBaseUrl+'photolysis-preferred-values/'+preferredValue.idPreferredValue+'/absorption-cross-sections'" download> 
              <v-tooltip left >
                    <template v-slot:activator="{ on }"> 
                      <v-btn icon v-on="on">
                      <v-icon>mdi-file-delimited</v-icon>
                      </v-btn>
                    </template>
                    <span>Download CSV file</span> 
              </v-tooltip>
             </a>
            </td>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
  </header-summary-table>
</v-container>
</template>

<script>
import HeaderSummaryTable from '../components/HeaderSummaryTable.vue';

export default {
  components: {
    HeaderSummaryTable
  },
  name: 'PhotolysisSummaryTable',

  props: ['classification', 'category', 'datasheets'],
  computed: {
    axiosBaseUrl() {
      return this.axios.defaults.baseURL;
    },
    filteredDatasheets() {
      return this.datasheets.filter(datasheet => datasheet.preferredValues.length>0);
    }
  }
};
</script>

<style scoped>
ul {
   list-style: none;
   padding: 0;
   margin: 0;
}

</style>
